import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

@Component({
  selector: 'app-figma-benin-rj',
  templateUrl: './figma-benin-rj.component.html',
  styleUrls: ['./figma-benin-rj.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FigmaBeninRjComponent implements AfterViewInit, OnDestroy {
  @Input() backgroundImage = '';
  @Input() plaqueImage = '';
  @Input() highlights: string[] = [];

  @ViewChild('rjSection') rjSection!: ElementRef<HTMLElement>;

  private ctx?: gsap.Context;

  ngAfterViewInit(): void {
    gsap.registerPlugin(ScrollTrigger);

    this.ctx = gsap.context(() => {
      const motionMedia = gsap.matchMedia();

      motionMedia.add('(prefers-reduced-motion: no-preference)', () => {
        // Animate the plaque image
        gsap.from('.benin-rj__plaque img', {
          scrollTrigger: {
            trigger: '.benin-rj__plaque',
            start: 'top 80%',
          },
          y: 60,
          opacity: 0,
          duration: 1.2,
          ease: 'power3.out'
        });

        // Stagger text sections
        const elementsToStagger = [
          '.benin-rj__intro',
          'h2',
          '.benin-rj__mission',
          '.benin-rj__cause-note',
          '.benin-rj__highlights',
          '.benin-rj__meta',
          '.benin-rj__description',
          '.benin-rj__relaunching',
          '.benin-rj__signature'
        ];

        gsap.from(elementsToStagger, {
          scrollTrigger: {
            trigger: '.benin-rj__intro',
            start: 'top 85%',
          },
          y: 30,
          opacity: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power2.out'
        });
      });
    }, this.rjSection.nativeElement);
  }

  ngOnDestroy(): void {
    this.ctx?.revert();
  }
}
